import $ from 'jquery';

export function initMobileMenu() {
  const swishyMemu = $('.js-swisyMobileMenu');
  swishyMemu.click(function(e) {
    e.preventDefault();
    swishyMemu.toggleClass('open');

    const mobileMenu = document.querySelector('.js-mobileMenuContainer');

    mobileMenu.classList.toggle('js-l-mobile');
  });
} 

